import React, { Component } from 'react'
import { Modal, Header, Button } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import Store from '../stores/Store'

/**
 * To use with any Store object. it will listen for errorMessage and disclose it.
 */
@observer
class ModalError extends Component {
  static propTypes = {
    store: PropTypes.instanceOf(Store)
  };

  render () {
    const { store } = this.props
    return (
      <>
        <Modal open={!!store.errorMessage}>
          <Header icon='exclamation circle' content='Oups' />
          <Modal.Content>
            <p>{store.errorMessage}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='green'
              inverted
              onClick={() => { store.clearError() }}
            >
              OK
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    )
  }
}

export default ModalError
